import { useState, useEffect } from 'react';

export interface ProjectEquipment {
  id: string;
  index: string;
  name: string;
  image: string;
  type: string;
  code: string;
  location: string;
  purchaseDate: string;
  status: string;
  statusColor: string;
  value: number;
}

export function useProjectEquipment() {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setData({
        kpis: [
          { label: 'Tổng số thiết bị', value: 48, unit: 'thiết bị', icon: 'ri-truck-line', color: 'text-blue-500', bg: 'bg-blue-50' },
          { label: 'Đang sử dụng', value: 28, unit: '', percent: 58, icon: 'ri-steering-2-line', color: 'text-emerald-500', bg: 'bg-emerald-50' },
          { label: 'Bảo dưỡng định kỳ', value: 6, unit: '', percent: 13, icon: 'ri-tools-line', color: 'text-amber-500', bg: 'bg-amber-50' },
          { label: 'Đang sửa chữa', value: 3, unit: '', percent: 6, icon: 'ri-hammer-line', color: 'text-rose-500', bg: 'bg-rose-50' },
          { label: 'Chờ sử dụng', value: 11, unit: '', percent: 23, icon: 'ri-pause-circle-line', color: 'text-slate-400', bg: 'bg-slate-50' },
          { label: 'Giá trị thiết bị', value: '7.850.000.000', unit: 'VND', icon: 'ri-money-dollar-circle-line', color: 'text-emerald-600', bg: 'bg-emerald-50' },
        ],
        equipment: [
          { id: '1', index: '01', name: 'Máy đào bánh xích Komatsu PC200-8', image: 'https://img.icons8.com/color/96/excavator.png', type: 'Máy thi công', code: 'EQP-001', location: 'Khu A - San nền', purchaseDate: '12/03/2024', status: 'Đang sử dụng', statusColor: 'bg-emerald-50 text-emerald-600', value: 1250000000 },
          { id: '2', index: '02', name: 'Xe ben tự đổ Howo 15 tấn', image: 'https://img.icons8.com/color/96/dump-truck.png', type: 'Phương tiện vận chuyển', code: 'EQP-002', location: 'Khu A - San nền', purchaseDate: '15/03/2024', status: 'Đang sử dụng', statusColor: 'bg-emerald-50 text-emerald-600', value: 980000000 },
          { id: '3', index: '03', name: 'Xe lu rung Sakai SV520D', image: 'https://img.icons8.com/color/96/steamroller.png', type: 'Máy thi công', code: 'EQP-003', location: 'Khu A - San nền', purchaseDate: '18/03/2024', status: 'Bảo dưỡng định kỳ', statusColor: 'bg-amber-50 text-amber-600', value: 650000000 },
          { id: '4', index: '04', name: 'Xe tưới nước Hino 9 khối', image: 'https://img.icons8.com/color/96/water-truck.png', type: 'Phương tiện chuyên dụng', code: 'EQP-004', location: 'Khu C - Cảnh quan', purchaseDate: '20/03/2024', status: 'Đang sử dụng', statusColor: 'bg-emerald-50 text-emerald-600', value: 420000000 },
          { id: '5', index: '05', name: 'Máy cưa xích Stihl MS 382', image: 'https://img.icons8.com/color/96/chainsaw.png', type: 'Thiết bị cầm tay', code: 'EQP-005', location: 'Khu C - Cảnh quan', purchaseDate: '22/03/2024', status: 'Chờ sử dụng', statusColor: 'bg-slate-100 text-slate-500', value: 12000000 },
        ],
        upcomingMaintenance: [
          { id: '1', name: 'Xe lu rung Sakai SV520D', code: 'EQP-003', date: '18/05/2024', remaining: 'Còn 2 ngày' },
          { id: '2', name: 'Máy đào Komatsu PC200-8', code: 'EQP-001', date: '21/05/2024', remaining: 'Còn 5 ngày' },
          { id: '3', name: 'Xe tưới nước Hino 9 khối', code: 'EQP-004', date: '25/05/2024', remaining: 'Còn 9 ngày' },
        ]
      });
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return { data, isLoading };
}
